import { useState, useRef } from "react";
import DropdownLoja from "./DropdownLoja";
import ConfigModal from "./ConfigModal";

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const [modalConfiguracoes, setModalConfiguracoes] = useState(false);
    const dropdownRef = useRef(null);

    return (
        <>
            {modalConfiguracoes && (
                <>
                    <ConfigModal onClose={() => setModalConfiguracoes(false)} />
                </>
            )}

            <div className="bg-white shadow p-2 flex justify-between items-center h-16">
                <div></div>
                <div className="flex space-x-4 items-center">
                    <DropdownLoja
                        ref={dropdownRef}
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        abrirModal={() => setModalConfiguracoes(true)}
                    />
                </div>
            </div>
        </>
    );
}